import { ProviderWorkerReportWorkflow } from '../../api/server/models/ProviderWorkerReportWorkflow';
import { ProviderWorkerReportMetric } from '../../api/server/models/ProviderWorkerReportMetric';
import { Variables } from '../base/variables/variables';

/**
 * Workflow hues (crosswalk §5), from `Variables` (NS-2). Five are the exact swatches the design names:
 * `#2E6BE6` Blue6, `#399E7C` Green6, `#F57A3D` Orange6, `#6D7E94` Gray6, `#B9C4D0` Gray4. The design's
 * mauve `#9B5C9B` has no swatch, so Unassigned uses the nearest existing token, `Colors.purple20`.
 */
export const WORKFLOW_HUES: Record<ProviderWorkerReportWorkflow, string> = {
    [ProviderWorkerReportWorkflow.Enter]: Variables.ThemeLight.PrimaryConstant6,
    [ProviderWorkerReportWorkflow.Payer]: Variables.ThemeLight.SuccessConstant6,
    [ProviderWorkerReportWorkflow.Provider]: Variables.ThemeLight.AttentionConstant6,
    [ProviderWorkerReportWorkflow.Worker]: Variables.Swatches.Gray6,
    [ProviderWorkerReportWorkflow.Unassigned]: Variables.Colors.purple20,
    [ProviderWorkerReportWorkflow.Unknown]: Variables.Swatches.Gray4,
};

/** The summary cards' dots. Total has none of its own, so it takes the neutral one. */
export const METRIC_DOTS: Record<ProviderWorkerReportMetric | 'TOTAL', string> = {
    TOTAL: Variables.Swatches.Gray5,
    [ProviderWorkerReportMetric.INPROGRESS]: Variables.ThemeLight.PrimaryConstant6,
    [ProviderWorkerReportMetric.WAITING]: Variables.ThemeLight.AttentionConstant6,
    [ProviderWorkerReportMetric.ERROR]: Variables.ThemeLight.WarningConstant6,
};

/** A `#rrggbb` token at an opacity — the shade scale is the token, thinned, never a new colour. */
export const withAlpha = (hex: string, alpha: number): string => {
    const value = hex.replace('#', '').slice(0, 6);
    const [r, g, b] = [0, 2, 4].map(start => parseInt(value.slice(start, start + 2), 16));

    return `rgba(${r}, ${g}, ${b}, ${Math.max(0, Math.min(1, alpha)).toFixed(3)})`;
};
